import dayjs from 'dayjs';

export const getDate = (time: string) => {
  return dayjs(time).format('DD MMM, YYYY HH:mm');
};
